<template>
    <div @click="clicked"><router-view v-if="isRouterAlive"></router-view></div>
</template>

<script>
import Vue from 'vue';
import { mapMutations } from 'vuex';
// import im from './util/im.js'
import siteinfo from './util/siteinfo.js'
export default {
    provide() {
        return {
            reload: this.reload,
            lastTime: null, //最后一次点击的时间
            currentTime: null //当前点击的时间
        };
    },
    data() {
        return {
            isRouterAlive: true
        };
    },
    mounted() {
        let t = this
        localStorage.removeItem('is_sys');
        localStorage.removeItem('uniacid');
        localStorage.removeItem('domain');
        // 更新用户登录状态
        let token = localStorage.getItem('Token')
        if ( token ){
        	t.changeLogin({Token: token})
        	t.checkToken();
        }else{
        	console.log('登录已失效');
        	t.checkToken(false)
        }
        t.getFarmSet();
        t.getSiteProgram()
        t.getFarmSetnav()
        t.getFarmSetfot()
        t.lastTime = new Date().getTime(); //第一次打开时，记录当前时间



        // 判断当前运行的设备
        // if (this._isMobile()) {
        //     // window.open('http://192.168.100.8/',"_self");

        // } else {
        //     return
        // }
    },
    methods: {
        isMobile() {
            let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
            return flag;
        },
        // 30分钟内未进行任何操作，需要重新登录
        clicked() {
            this.currentTime = new Date().getTime(); //记录这次点击的时间
            let name = this.$router.app._route.name
            let token = localStorage.getItem('Token')
            if (name === '登录'){
                this.lastTime = new Date().getTime();
                return
            }
            if(token === null || !token){
                this.lastTime = new Date().getTime();
                return
            }
            if (this.currentTime - this.lastTime > 1000 * 60 * 30) {
                //判断上次最后一次点击的时间和这次点击的时间间隔是否大于30分钟
                this.$confirm('登录已超时，请重新登录！', '提示', {
                    showConfirmButton: true,
                    showCancelButton: false,
                    type: 'warning',
                    center: true
                }).then( ()=>{
                    localStorage.removeItem('Token');
                    this.lastTime = new Date().getTime();
                    return this.$router.push('/signin');
                })

            } else {
                this.lastTime = new Date().getTime(); //如果在30分钟内点击，则把这次点击的时间记录覆盖掉之前存的最后一次点击的时间
            }
        },

        // 更新页面方法
        reload() {
            this.isRouterAlive = false;
            this.$nextTick(function() {
                this.isRouterAlive = true;
            });
        },

        //检查token是否有效
        checkToken(is_token=true){
        	let t = this
        	let clientid = 0
        	t.$http.post('/app/verify',{ clientid }).then(res=>{
        		if ( res.data.errorCode === 9 ){
        			t.logout()
        		}
        	}).catch(err=>{
        		console.log(err);
        	})
        },

        // 获取pid
        getSiteProgram(){
            let t = this, d = window.location.host
            let a = d.split(':')
            let data={type:'web',domain: a[0]}
            // let data={type:'web',domain: '1063.pc.farmkd.com'}
            this.$http.post('/app/getSiteProgram',data).then(res =>{
                let d = res.data.data
                if(d.is_open_sass == 1){   //开启sass
                    if(d.program == null || d.site == null){  //
                        this.$router.push('/none')
                        return
                    }
                    localStorage.setItem('is_sys', d.site.is_sys);
                    localStorage.setItem('uniacid', d.site.program_id);
                    localStorage.setItem('domain', d.site.domain);
                } else {
                    localStorage.setItem('is_sys', 0);
                    localStorage.setItem('uniacid', siteinfo.siteinfo.uniacid);
                    // localStorage.setItem('domain', d.site.domain);
                }

            }).catch(err =>{console.log(err)})
        },

        // 获取自定义首页顶部
        getFarmSetnav(){
            let t = this
            t.$http.get('/app/getFarmSet', {
                params: {
                    keys: ['website_hander_type','website_hander_title','website_hander_logo','website_hander_register','website_hander_list']
                }
            }).then(res =>{
                if(res.data.data){
                	let d = res.data.data
                	if(d.website_hander_type == 2){
                	    d.website_hander_list = JSON.parse(d.website_hander_list)
                	}
                	localStorage.setItem('TopbarList',JSON.stringify(d))
                    document.title = d.website_hander_title
                	// localStorage.setItem('pageName',d.website_hander_title)
                }
            }).catch(err =>{console.log(err)})
        },

        // 获取自定义首页底部
        getFarmSetfot(){
            let t = this
            t.$http.get('/app/getFarmSet', {
                params: {
                    keys: ['accounturl','wechaturl','iosurl','androidurl','codetitle','codeurl','fotphone','fotdate','mailbox','record']
                }
            }).then(res =>{
                if(res.data.data){
                	let d = res.data.data
                    localStorage.setItem('footer',JSON.stringify(d))
                }
            }).catch(err =>{console.log(err)})
        },

        // 获取全局颜色
        getFarmSet() {
            let t = this;
            Vue.prototype.bColor = {
                bgColor: {
                    background: 'linear-gradient(to right, #0081ff,#1cbbb4)'
                },
                color: {
                    color: '#0081ff'
                },
                background: {
                    background: '#0081ff'
                },
                mainColor: '#0081ff',
                assistColor: '#1cbbb4'
            };
            t.$http.get('/app/getFarmSet', {
                params: {
                    keys: ['theme_color', 'theme_assit_color']
                }
            }).then(res => {
                if (res.data.data) {
                    let d = res.data.data;
                    if (d.theme_color != '' && d.theme_assit_color != '') {
                        let bColor = {
                            bgColor: {
                                background: 'linear-gradient(to right, ' + d.theme_assit_color + ',' + d.theme_color + ')'
                            },
                            color: {
                                color: d.theme_color
                            },
                            background: {
                                background: d.theme_color
                            },
                            mainColor: d.theme_color,
                            assistColor: d.theme_assit_color
                        };

                        Vue.prototype.bColor = bColor;

                        Vue.prototype.iconBg = {
                            background: '-webkit-linear-gradient(45deg, ' + d.theme_assit_color + ', ' + d.theme_color + ')',
                            '-webkit-text-fill-color': 'transparent',
                            '-webkit-background-clip': 'text'
                        };
                        console.log(Vue.prototype.bColor);
                    }
                }
            }).catch(err => {
                console.log(err);
            });
        },
        ...mapMutations(['changeLogin','logout']),
    }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/App.vue